import { ForwardedRef, forwardRef, ReactNode } from "react";

import { sanitizer } from "./sanitize";
import { StyledHtml } from "./html.styles";

export const Html = forwardRef(function Html(
  { content, noTranslate }: { content: string; noTranslate?: boolean },
  ref: ForwardedRef<HTMLDivElement>,
): ReactNode {
  return (
    <StyledHtml
      // Opt out of browser auto-translation for externally-sourced preformatted
      // content (e.g. the HTML/OPMET widget), which garbles when translated.
      translate={noTranslate ? "no" : undefined}
      dangerouslySetInnerHTML={{ __html: sanitizer(content) }}
      ref={ref}
    />
  );
});
